import LoqateAddressSearch, {
  type Address as LoqateAddress,
} from "react-loqate";
import { LOQATE_API_KEY } from "@/config";
import { Input } from "@/components/ui/Input";
import classes from "./AddressAutocomplete.module.scss";
import type { AddressAutocompleteProps } from "./AddressAutocompleteProps";
import mergeRefs from "merge-refs";
import type { RefObject } from "react";
import { countryNames } from "@/utils/countries";

const LOCALE = "en_GB";
const CONTRIES = ["GBR"];

function normalizeLines(lines: string[]): string {
  return lines.filter((line) => line.trim() !== "").join(", ");
}

type InputProps = {
  ref?: RefObject<HTMLInputElement | null>;
};

export function AddressAutocomplete(props: AddressAutocompleteProps) {
  const { onSelect, className, ...inputProps } = props;

  const handleSelectAddress = (selectedAddress: LoqateAddress) => {
    const addressLine1 = normalizeLines([
      selectedAddress.Line1,
      selectedAddress.Line2,
    ]);

    const addressLine2 = normalizeLines([
      selectedAddress.Line3,
      selectedAddress.Line4,
      selectedAddress.Line5,
    ]);

    const country = countryNames.includes(selectedAddress.CountryName)
      ? selectedAddress.CountryName
      : "";

    onSelect({
      "address-line-1": addressLine1,
      "address-line-2": addressLine2,
      country,
      city: selectedAddress.City,
      region: selectedAddress.ProvinceName,
      "postal-code": selectedAddress.PostalCode,
    });
  };

  return (
    <LoqateAddressSearch
      locale={LOCALE}
      apiKey={LOQATE_API_KEY}
      onSelect={handleSelectAddress}
      countries={CONTRIES}
      classes={{
        input: className,
        list: classes.locateList,
        listItem: classes.locateItem,
      }}
      components={{
        Input: (props: InputProps) => {
          return (
            <Input
              {...props}
              {...inputProps}
              ref={mergeRefs(inputProps.ref, props.ref)}
            />
          );
        },
      }}
    />
  );
}
